import { Module } from 'vuex'
import { RootState } from '@/store'
import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'
import { PipelineConnection } from '@/api/model/pipeline-connection'

export interface PipelineConnectionsState {
    loading: boolean,
    loaded: boolean,
    error: string|null,
    incomingConnections: PipelineConnection[],
    outgoingConnections: PipelineConnection[],
}

const state: PipelineConnectionsState = {
    loading: false,
    loaded: false,
    error: null,
    incomingConnections: [],
    outgoingConnections: [],
}

export const PipelineConnectionsModule: Module<PipelineConnectionsState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
